<sh-modal
  *ngIf="open"
  [visible]="open"
  sticky="true"
  id="loginModal"
  modal-width="85%"
  modal-height="60%"
  class="modal-container"
>
  <sh-text slot="header">
    <sh-text size="header-1">
      Login: Your Personalized Training, One Tap Away
      <sh-icon
        button
        icon="cancel"
        class="close-button"
        size="s"
        (click)="closeModal()"
      ></sh-icon>
    </sh-text>
  </sh-text>

  <div class="modal-content">
    <div class="modal-left">
      <sh-text size="header-2" >For iOS/iPad Devices</sh-text>
      <ul class="instruction-list">
        <li><sh-text size="body-1">
          Begin by opening the
          <a href="https://apps.apple.com/us/app/expertguidance/id1505323191" style="color: #5E1EBE;" target="_blank">
            link
          </a>
          or scanning the QR code. Then select "View in App Store".</sh-text>
        </li>
        <li><sh-text size="body-1">Click on the blue installation icon.</sh-text></li>
        <li><sh-text size="body-1">When the app tile appears on your iPad home screen, launch the ExpertGuidance app.</sh-text></li>
        <li><sh-text size="body-1">Sign in using the credentials provided via a separate email.</sh-text></li>
        <li><sh-text size="body-1">Initiate SiteViewer via the app’s opening screen.</sh-text></li>
        <li><sh-text size="body-1">Navigate to the “Customer Area” to explore your assigned site.</sh-text></li>
      </ul>
    </div>

    <div class="modal-right">
      <img src="/assets/images/QR-Code.png" alt="QR Code iOS" />
      <img src="/assets/images/ExpertGuidance_ios_icon.png" alt="iOS App Icon" />
      <img src="/assets/images/SiteViewer_icon.png" alt="SiteViewer Icon" />
      <img src="/assets/images/Customer_Area_icon.png" alt="Customer Area Icon" />
    </div>

    <div class="modal-left">
        <sh-text size="header-2" >For Windows Devices</sh-text>
      <ul class="instruction-list">
        <li><sh-text size="body-1">
            To get started, download the application by clicking this <span (click)="downloadLatestBuild()" style="color: #5E1EBE; text-decoration: underline; cursor: pointer;"> link</span> or scan the QR.
        </sh-text></li>
        <li><sh-text size="body-1">Allow the automatic download to complete.</sh-text></li>
        <li><sh-text size="body-1">
          Locate the file named <strong>"siemens-healthineers_CS_ExpertGuidance_X.X.X_VAXXX.msi"</strong>
          in your browser’s download bar or default folder.</sh-text>
        </li>
        <li><sh-text size="body-1">Run the file and follow the setup wizard’s guidance.</sh-text></li>
        <li><sh-text size="body-1">Launch the app using the desktop shortcut.</sh-text></li>
        <li><sh-text size="body-1">Log in using the credentials sent via separate email.</sh-text></li>
        <li><sh-text size="body-1">Select “SiteViewer” from the in-app menu.</sh-text></li>
        <li><sh-text size="body-1">Navigate to the “Customer Area” to view your assigned site.</sh-text></li>
      </ul>
    </div>

    <div class="modal-right">
      <img [src]="windows_QR_Code" alt="QR Code Windows" />
      <img src="/assets/images/ExpertGuidance_msi_icon.png" alt="MSI Icon" />
      <img src="/assets/images/ExpertGuidance_windows_icon.png" alt="Windows App Icon" />
      <img src="/assets/images/SiteViewer_icon.png" alt="SiteViewer Icon" />
      <img src="/assets/images/Customer_Area_icon.png" alt="Customer Area Icon" />
    </div>
  </div>
</sh-modal>
